//#region IMPORTS
import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { DigitalFrame, DigitalFrameState } from "../../models/digitalFrame";
import { RootState } from "../../store/configureStore";
import agent from "../../api/agent";
//#endregion

//#region INIT
// Set initial state
const initialExtraState: DigitalFrameState = {
  digitalFrames_loaded: false,
  metaData: null,
  loading: false,
  status: "idle",
};
//#endregion

//#region CREATE ADPATER
const digitalFramesAdapter = createEntityAdapter<DigitalFrame>();
//#endregion

//#region READ
// Fetch All
export const fetchDigitalFramesAsync = createAsyncThunk<
  DigitalFrame[],
  void,
  { state: RootState }
>("digitalFrames/fetchDigitalFramesAsync", async (_, thunkAPI) => {
  try {
    const response = await agent.StoreManagement.listDigitalFrames();
    thunkAPI.dispatch(setDigitalFramesMetaData(response.meta));
    return response.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue({ error: error.data });
  }
});
//#endregion

//#region CREATE REDUCER SLICE
export const digitalFrameSlice = createSlice({
  name: "digitalFrames",
  initialState:
    digitalFramesAdapter.getInitialState<DigitalFrameState>(initialExtraState),
  reducers: {
    setDigitalFramesMetaData: (state, action) => {
      state.metaData = action.payload;
    },
    clearDigitalFrames: () =>
      digitalFramesAdapter.getInitialState<DigitalFrameState>(
        initialExtraState
      ),
  },
  extraReducers: (builder) => {
    // FETCH digitalFrames
    builder.addCase(fetchDigitalFramesAsync.pending, (state) => {
      state.status = "pendingFetchDigitalFrames";
      state.loading = true;
    });
    builder.addCase(fetchDigitalFramesAsync.fulfilled, (state, action) => {
      digitalFramesAdapter.setAll(state, action.payload);
      state.status = "idle";
      state.digitalFrames_loaded = true;
      state.loading = false;
    });
    builder.addCase(fetchDigitalFramesAsync.rejected, (state) => {
      state.status = "idle";
      state.loading = false;
    });
  },
});
//#endregion

//#region NORMALISED STATE
export const digitalFrameSelectors = digitalFramesAdapter.getSelectors(
  (state: RootState) => state.digitalFramesManagement
);
//#endregion

//#region EXPORT
export const { setDigitalFramesMetaData, clearDigitalFrames } =
  digitalFrameSlice.actions;
//#endregion
